import React from "react"
import { useSelector, useDispatch } from "react-redux"
import { Link, useLocation } from "react-router-dom"
import { Alert, Card, CardBody, Col, Container, Row } from "reactstrap"

// import images
import logodark from "../../assets/images/logo-dark.png"
import logolight from "../../assets/images/logo-light.png"
import { useEffect } from "react"

import { EmailVerify } from "../../store/auth/forgetpwd/actions"

const ConfirmMail = () => {
  const dispatch = useDispatch()

  //get query  params

  const { search } = useLocation()
  const parameters = new URLSearchParams(search)
  const token = parameters.get("token")

  useEffect(() => {
    dispatch(EmailVerify(token))
  }, [])

  //meta title
  document.title =
    "Confirm Mail | TenderSoftware - Flexi TracBoard"

  const { verifyError } = useSelector(state => ({
    verifyError: state.ForgetPassword,
  }))

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="text-center mb-5 text-muted">
                <Link to="dashboard" className="d-block auth-logo">
                  <img
                    src={logodark}
                    alt=""
                    height="20"
                    className="auth-logo-dark mx-auto"
                  />
                  <img
                    src={logolight}
                    alt=""
                    height="F20"
                    className="auth-logo-light mx-auto"
                  />
                </Link>
                <p className="mt-3">
                  {verifyError?.verifySuccessMsg?.statusCode == 200
                    ? "Success Page"
                    : "Error Page"}
                </p>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card>
                <CardBody>
                  <div className="p-2">
                    <div className="text-center">
                      <div className="avatar-md mx-auto">
                        <div className="avatar-title rounded-circle bg-light">
                          {!verifyError?.verifySuccessMsg?.statusCode == 200  ? (
                            <i className="bx bxs-error h1 mb-0 text-primary"></i>
                          ) : (
                            <i className="dripicons-thumbs-up h1 mb-0 text-primary"></i>
                          )}
                        </div>
                      </div>
                      <div className="p-2 mt-4">
                      {console.log(verifyError,"verifyError1")}
                      
                      
                        {verifyError?.verifySuccessMsg?.statusCode == 200 ? (
                          <Alert color="success">
                            {verifyError?.verifySuccessMsg?.message}
                          </Alert>
                        ) : (
                          <Alert color="danger">
                            {verifyError?.verifyErrorMsg?.message}
                          </Alert>
                        )}

                        {/* <p className="text-muted">
                          At vero eos et accusamus et iusto odio dignissimos
                          ducimus qui blanditiis praesentium voluptatum
                          deleniti atque corrupti quos dolores et
                        </p> */}
                        <div className="mt-4">
                          <Link to="/login" className="btn btn-success">
                            Back to Login
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>© {new Date().getFullYear()} TenderSoftware.</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ConfirmMail
